import { useEditorChrome } from '../../core/context/EditorChromeContext';
import { useEditorProps } from '../../core/context/EditorPropsContext';
import { ToolbarSeparator } from '../../ui/ToolbarButton';
import { LanguageButtons } from '../multi-language/LanguageButtons';
import { InsertGroup } from './InsertGroup';
import { ParagraphGroup } from './ParagraphGroup';
import { TextFormatGroup } from './TextFormatGroup';
import { useToolbarState } from './useToolbarState';

/**
 * The rich-text toolbar, docked inside the top (or bottom, with `toolbarPosition`) of the editor frame.
 * - Only shown while the editor is active, matching Froala's `data-froala-focused` behaviour.
 * - The language pills sit at its right end when multi-language is on.
 * - `data-size` drives the compact size-S buttons (see `toolbarButtonClasses`).
 */
export const Toolbar = () => {
  const { disabled = false, size = 'm', toolbarPosition = 'top' } = useEditorProps();
  const { focused } = useEditorChrome();
  const state = useToolbarState();

  if (!focused) return null;

  return (
    <div
      data-size={size}
      className={`group/toolbar border-accent-4-100 flex flex-wrap items-center bg-white py-1 ${toolbarPosition === 'bottom' ? 'rounded-b-md border-t' : 'rounded-t-md border-b'}`}
    >
      <TextFormatGroup state={state} disabled={disabled} />
      <ToolbarSeparator />
      <ParagraphGroup state={state} disabled={disabled} />
      <ToolbarSeparator />
      <InsertGroup state={state} disabled={disabled} />
      <LanguageButtons className="mr-2 ml-auto" />
    </div>
  );
};
